export default __webpack_public_path__ + "static/media/USD1.f1ea7840.png";